import { Roles } from "../enums/Roles";
import { Project } from "../stores/ProjectsStore";
import { Employee } from "../models/Employee";

export type ProjectPermission = "read" | "write" | "full";
export type LocalProjectRole = "admin" | "user" | "viewer" | null;

const globalProjectRoles = new Set<number>([Roles.Owner, Roles.Admin, Roles.Manager]);

export const getLocalProjectRole = (project?: Project | null, userId?: string | number): LocalProjectRole => {
  if (!project || userId == null) return null;

  const id = String(userId);
  const members = [
    ...(project.members || []),
    ...(project.developers || []),
    ...(project.userProjects || []),
  ];

  const member: any = members.find((item: any) =>
    String(item.id) === id ||
    String(item.companyUserId) === id ||
    String(item.companyUser?.id) === id
  );

  const title = (member?.role?.title || member?.Role?.Title || "").toLowerCase();
  if (title === "admin" || title === "user" || title === "viewer") {
    return title;
  }

  return null;
};

export const hasGlobalProjectRole = (user?: Employee | null): boolean => {
  return user?.roles?.some(role => globalProjectRoles.has(role.id)) === true;
};

export const canAccessProject = (
  project: Project | null | undefined,
  user: Employee | null | undefined,
  permission: ProjectPermission
): boolean => {
  const localRole = getLocalProjectRole(project, user?.id);

  if (localRole === "viewer") return permission === "read";
  if (localRole === "user") return permission === "read" || permission === "write";
  if (localRole === "admin") return true;

  return hasGlobalProjectRole(user);
};